'use client';

import { useMemo } from 'react';
import { PostSchema } from '@ametista-ai/api-schema';
import { Group, Stack, Text } from '@mantine/core';
import { useDebouncedCallback } from '@mantine/hooks';
import { useUpdatePost } from '@/queries/posts/useUpdatePost';
import { useTemplates } from '@/queries/templates/useTemplates';
import { Icon } from '@/ui';
import { ContentField } from '../ContentField/ContentField';
import { ToggleActivityLogButton } from './ToggleActivityLogButton';

export function PostContent({ post }: { post: PostSchema }) {
  const { mutate: updatePost } = useUpdatePost();
  const { data: templates = [] } = useTemplates();

  const editorTemplates = useMemo(() => {
    return templates.map((template) => ({
      id: template.id,
      name: template.title,
      content: template.description ?? '',
    }));
  }, [templates]);

  const debouncedUpdatePost = useDebouncedCallback(
    (value: string) => {
      updatePost({ id: post.id, content: value });
    },
    {
      delay: 300,
      flushOnUnmount: true,
    }
  );

  return (
    <Stack gap="sm">
      <Group gap="3xs">
        <Icon name="contract" />
        <Text size="md" fw={500}>
          Post text
        </Text>
      </Group>
      <ContentField
        content={post.content ?? ''}
        onChange={debouncedUpdatePost}
        templates={editorTemplates}
        rightSection={<ToggleActivityLogButton post={post} />}
      />
    </Stack>
  );
}
